/* Start gehoste video's met autoplay pas zodra ze in beeld komen,
   en pauzeer ze buiten beeld. Voorkomt dat de volledige video
   (vaak vele MB's) bij page load wordt gedownload. */
(function () {
	if (window.__clubVideoLazyAutoplay) return;
	window.__clubVideoLazyAutoplay = true;

	function init() {
		var videos = document.querySelectorAll('.video-lazy-autoplay--true video');
		if (!videos.length) return;

		if (!('IntersectionObserver' in window)) {
			videos.forEach(function (v) {
				if (v.play) v.play().catch(function () {});
			});
			return;
		}

		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					var video = entry.target;
					if (entry.isIntersecting) {
						video.muted = true;
						if (video.play) video.play().catch(function () {});
					} else if (!video.paused) {
						video.pause();
					}
				});
			},
			{ rootMargin: '150px' }
		);

		videos.forEach(function (v) {
			io.observe(v);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
